
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-black/90 backdrop-blur-sm border-b border-amber-500/20 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-amber-400" style={{fontFamily: "Pacifico, serif"}}>奇跡のブラックアウト</h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-white hover:text-amber-400 transition-colors cursor-pointer">ホーム</Link>
              <Link to="/terms" className="text-white hover:text-amber-400 transition-colors cursor-pointer">利用規約</Link>
              <Link to="/privacy" className="text-white hover:text-amber-400 transition-colors cursor-pointer">プライバシーポリシー</Link>
              <Link to="/contact" className="text-white hover:text-amber-400 transition-colors cursor-pointer">お問い合わせ</Link>
            </nav>
            <div className="md:hidden">
              <button className="text-white w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black" 
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/57af078e5f295ead8cf1f605e580a654.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
            奇跡のブラックアウト
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed">
            究極のフリーズ体験をあなたのスマートフォンで<br />
            1/8192、1/16384の奇跡を感じよう
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-gradient-to-r from-red-600 to-amber-500 hover:from-red-7 00 hover:to-amber-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
              <i className="ri-google-play-line mr-2"></i>
              Google Playで入手
            </button>
            <button className="bg-gradient-to-r from-gray-700 to-gray-600 hover:from-gray-600 hover:to-gray-500 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
              <i className="ri-apple-line mr-2"></i>
              App Storeで入手
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-amber-400 mb-6">主要機能</h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              奇跡のブラックアウトの魅力的な機能をご紹介します
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/40 transition-colors">
              <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-amber-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-gamepad-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">2つのゲームモード</h3>
              <ul className="text-gray-300 space-y-2">
                <li>• 8192モード（確率1/8192）</li>
                <li>• 16384モード（確率1/16384）</li>
                <li>• 通常フリーズ vs 神フリーズ</li>
              </ul>
            </div>

            <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/40 transition-colors">
              <div className="w-16 h-16 bg-gradient-to-r from-amber-600 to-yellow-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hand-coin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">タップストックシステム</h3>
              <ul className="text-gray-300 space-y-2">
                <li>• 初期ストック2000回</li>
                <li>• リワード広告でチャージ</li>
                <li>• 効率的なタップ管理</li>
              </ul>
            </div>

            <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/40 transition-colors">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-5 0 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-bar-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">統計データ管理</h3>
              <ul className="text-gray-300 space-y-2">
                <li>• 詳細な記録システム</li>
                <li>• モード別統計</li>
                <li>• データリセット機能</li>
              </ul>
            </div>

            <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/40 transition-colors">
              <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-teal-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">ミッションシステム</h3>
              <ul className="text-gray-300 space-y-2">
                <li>• 多くのミッション</li>
                <li>• 進捗管理機能</li>
                <li>• 達成報酬システム</li>
              </ul>
            </div>

            <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/40 transition-colors">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-magic-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">フリーズ演出</h3>
              <ul className="text-gray-300 space-y-2">
                <li>• 迫力のブラックアウト</li>
                <li>• 鼓動エフェクト</li>
                <li>• 777表示アニメーション</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-900/30">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-amber-400 mb-6">アプリスクリーンショット</h2>
            <p className="text-xl text-gray-400">
              実際の画面をご覧ください
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-gradient-to-b from-gray-800 to-black rounded-2xl p-4 border border-amber-500/20">
                <img 
                  src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/d294c149754b71b5027290a417ccc759.png"
                  alt="メイン画面"
                  className="w-full rounded-xl object-top object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-amber-400 mt-4">メイン画面</h3>
              <p className="text-gray-400 mt-2">大きなPUSHボタンとストック表示</p>
            </div>

            <div className="text-center">
              <div className="bg-gradient-to-b from-gray-800 to-black rounded-2xl p-4 border border-amber-500/20">
                <img 
                  src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/da33fb5f81db8125eeaed38f394c9223.png"
                  alt="フリーズ演出画面"
                  className="w-full rounded-xl object-top object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-amber-400 mt-4">フリーズ演出</h3>
              <p className="text-gray-400 mt-2">迫力の777表示と特殊効果</p>
            </div>

            <div className="text-center">
              <div className="bg-gradient-to-b from-gray-800 to-black rounded-2xl p-4 border border-amber-500/20">
                <img 
                  src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/f81e2187b5f951762997c5668509fa01.png"
                  alt="ミッション画面"
                  className="w-full rounded-xl object-top object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-amber-400 mt-4">ミッション画面</h3>
              <p className="text-gray-400 mt-2">チャレンジと進捗管理</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-red-900/30 to-amber-900/30">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-400 mb-6">
            今すぐダウンロード
          </h2>
          <p className="text-xl text-gray-300 mb-12">
            究極のフリーズ体験があなたを待っています
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button className="bg-gradient-to-r from-red-600 to-amber-500 hover:from-red-700 hover:to-amber-600 text-white px-10 py-5 rounded-full text-xl font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
              <i className="ri-google-play-fill mr-3"></i>
              Google Play
            </button>
            <button className="bg-gradient-to-r from-gray-700 to-gray-600 hover:from-gray-600 hover:to-gray-500 text-white px-10 py-5 rounded-full text-xl font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
              <i className="ri-apple-fill mr-3"></i>
              App Store
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border-t border-amber-500/20 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold text-amber-400 mb-4" style={{fontFamily: "Pacifico, serif"}}>奇跡のブラックアウト</h3>
              <p className="text-gray-400 mb-4">
                究極のフリーズ体験をスマートフォンで。1/8192、1/16384の奇跡を感じよう。
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">リンク</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">ホーム</Link></li>
                <li><Link to="/terms" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">利用規約</Link></li>
                <li><Link to="/privacy" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">プライバシーポリシー</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">お問い合わせ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400">
              © 2025 奇跡のブラックアウト. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
